import { rest } from 'msw'
import config from '~/config'
import { user } from '~/__mocks__/api/fake-data/users'

const apiBaseUrl = `${config.api.baseURL}/v1/admin/auth/`

const registerGleam = rest.post(
  `${apiBaseUrl}register-gleam`,
  (_req, res, ctx) => res(ctx.status(200), ctx.json({ token: user.authToken })),
)

const login = rest.post(`${apiBaseUrl}login-gleam`, (_req, res, ctx) => {
  const { email, password } = _req.body as any
  if (email === 'samihamaizi3645@gmail.com' && password === '1234') {
    return res(ctx.status(200), ctx.json({ token: user.authToken }))
  }
  return res(ctx.status(401))
})
const changePassword = rest.patch(
  `${apiBaseUrl}change-password`,
  (_req, res, ctx) => {
    const { currentPassword } = _req.body as any
    if (currentPassword !== '1234') {
      return res(ctx.status(401))
    }
    return res(ctx.status(200), ctx.json(true))
  },
)
const forgotPassword = rest.post(
  `${apiBaseUrl}forgot-password`,
  (_req, res, ctx) => res(ctx.status(200), ctx.json('sent')),
)
const resetPassword = rest.patch(
  `${apiBaseUrl}reset-password`,
  (_req, res, ctx) => res(ctx.status(200), ctx.json(true)),
)

export const authHandler = [
  registerGleam,
  login,
  changePassword,
  forgotPassword,
  resetPassword,
]
